export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.status   = json.status
      this.columns  = json.columns
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries
      
      this.status.ratio = 0

      this.gmx_tableCoordinates('x', this.columns, 5)



      let total = this.rawData[this.status.totalRef]
      this.columns.forEach((d,i)=> {

        d.value = this.rawData[d.code]
        d.ratio = (d.value>0) ? d.value/total : 0

      })

    },

  }
}